import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/dist/backdrop.css'
import 'tippy.js/themes/light.css'
import 'tippy.js/animations/perspective.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueTippy, {
    defaultProps: {
      delay: [250, 0],
      arrow: true,
      theme: 'light',
      placement: 'bottom',
      trigger: 'mouseenter',
      animation: 'perspective',
      allowHTML: true,
      touch: false
    },
    flipDuration: 0
  })
})
